import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  action?: { label: string; to: string };
  children?: ReactNode;
}

export default function SectionHeading({ title, subtitle, icon, action, children }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="min-w-0">
        <h2 className="font-heading font-extrabold text-xl md:text-2xl text-foreground-950 flex items-center gap-2">
          {icon && (
            <span className="w-8 h-8 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center shrink-0">
              <i className={`${icon} text-base`} aria-hidden="true"></i>
            </span>
          )}
          {title}
        </h2>
        {subtitle && <p className="mt-2 text-xs md:text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {action && (
        <Link
          to={action.to}
          className="text-xs md:text-sm text-foreground-500 hover:text-primary-600 cursor-pointer flex items-center gap-1 whitespace-nowrap transition-colors shrink-0"
        >
          {action.label}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      )}
      {children}
    </div>
  );
}